function initializeCartAlsoLikeSlider() {
  const alsoLikeContainer = document.querySelector('.cart-also-like-slider');
  if (alsoLikeContainer) {      
    const cartAlsoLikeSlider = new Swiper('.cart-also-like-slider', {
      spaceBetween: 15,
      slidesPerView: 3.2,
      navigation: {
        prevEl: '.also-like-btn-prev',
        nextEl: '.also-like-btn-next',
      },
    });
  }
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
    
    initializeCartAlsoLikeSlider();
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
    initializeCartAlsoLikeSlider();
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.dataset.quantityVariantId);
  }

  onCartUpdate() {
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
          initializeCartAlsoLikeSlider();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
          initializeCartAlsoLikeSlider();
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
        let message = '';
        if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        
        initializeCartAlsoLikeSlider();
      })
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements].forEach((overlay) => overlay && overlay.classList.remove('hidden'));
    [...cartDrawerItemElements].forEach((overlay) => overlay && overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements].forEach((overlay) => overlay && overlay.classList.add('hidden'));
    [...cartDrawerItemElements].forEach((overlay) => overlay && overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

/* Auto-add Book and/or Gift Box based on cart conditions
const BOOK_VARIANT_ID = 51376765174093;
const GIFT_BOX_VARIANT_ID = 52725140291917;
const TARGET_COLLECTION_HANDLE = 'amulet-sets';
const MINIMUM_SPEND = 6500; // €65.00 in cents

let isAddingGifts = false;
let isRemovingGifts = false;
let amuletSetsProductIds = new Set();
let collectionLoaded = false;

function fetchCollectionProducts() {
  if (collectionLoaded) return Promise.resolve(amuletSetsProductIds);
  
  console.log('🔄 Fetching amulet-sets collection...');
  return fetch(`/collections/${TARGET_COLLECTION_HANDLE}/products.json?limit=250`)
    .then(response => response.json())
    .then(data => {
      amuletSetsProductIds = new Set(data.products.map(p => p.id));
      collectionLoaded = true;
      console.log('✅ Amulet sets product IDs loaded:', Array.from(amuletSetsProductIds));
      return amuletSetsProductIds;
    })
    .catch(error => {
      console.error('❌ Error fetching collection:', error);
      return amuletSetsProductIds;
    });
}

function checkCartAndAddGifts() {
  console.log('🔍 checkCartAndAddGifts called');
  
  if (isAddingGifts || isRemovingGifts) {
    console.log('⏸️ Already processing gifts, skipping...');
    return;
  }
  
  fetchCollectionProducts().then(() => {
    console.log('📋 Collection loaded, now fetching cart...');
    return fetch('/cart.js');
  })
  .then(response => response.json())
  .then(cart => {
    console.log('🛒 Cart items:', cart.items.map(i => i.product_title));
    console.log('💰 Cart total:', cart.total_price / 100, '€');
    
    // Check if cart has amulet set items (excluding book and box)
    const hasAmuletSetItem = cart.items.some(item => {
      const isFromCollection = amuletSetsProductIds.has(item.product_id);
      const isNotGiftBox = item.variant_id != GIFT_BOX_VARIANT_ID;
      const isNotBook = item.variant_id != BOOK_VARIANT_ID;
      
      console.log(`📦 "${item.product_title}" - From collection: ${isFromCollection}`);
      
      return isFromCollection && isNotGiftBox && isNotBook;
    });
    
    // Check cart total (excluding book and box)
    const cartTotalWithoutGifts = cart.items
      .filter(item => item.variant_id != BOOK_VARIANT_ID && item.variant_id != GIFT_BOX_VARIANT_ID)
      .reduce((sum, item) => sum + item.final_line_price, 0);
    
    const meetsMinimumSpend = cartTotalWithoutGifts >= MINIMUM_SPEND;
    
    const bookInCart = cart.items.some(item => item.variant_id == BOOK_VARIANT_ID);
    const giftBoxInCart = cart.items.some(item => item.variant_id == GIFT_BOX_VARIANT_ID);
    
    console.log(`\n📊 CONDITIONS:`);
    console.log(`   - Cart total (excl. gifts): €${(cartTotalWithoutGifts / 100).toFixed(2)}`);
    console.log(`   - Meets €65 minimum: ${meetsMinimumSpend}`);
    console.log(`   - Has amulet set: ${hasAmuletSetItem}`);
    console.log(`   - Book in cart: ${bookInCart}`);
    console.log(`   - Gift box in cart: ${giftBoxInCart}\n`);
    
    const itemsToAdd = [];
    
    // LOGIC 1: Add book if cart >= €65 and book not in cart
    if (meetsMinimumSpend && !bookInCart) {
      console.log('✅ Condition met: Adding BOOK (cart >= €65)');
      itemsToAdd.push({ id: BOOK_VARIANT_ID, quantity: 1 });
    }
    
    // LOGIC 2: Add box if has amulet set item and box not in cart
    if (hasAmuletSetItem && !giftBoxInCart) {
      console.log('✅ Condition met: Adding BOX (has amulet set)');
      itemsToAdd.push({ id: GIFT_BOX_VARIANT_ID, quantity: 1, properties: { '_auto_added_gift': 'true' } });
    }
    
    // Add items if needed
    if (itemsToAdd.length > 0) {
      isAddingGifts = true;
      console.log(`➕ ADDING ${itemsToAdd.length} GIFT(S) NOW...`);
      
      Promise.all(itemsToAdd.map(item => 
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(item)
        })
      ))
      .then(() => {
        console.log('✅ Gifts added successfully!');
        return Promise.all([
          fetch(`${routes.cart_url}?section_id=cart-drawer`).then(r => r.text()),
          fetch(`${routes.cart_url}?section_id=cart-icon-bubble`).then(r => r.text())
        ]);
      })
      .then(([drawerHtml, iconHtml]) => {
        // Update drawer
        const drawerDoc = new DOMParser().parseFromString(drawerHtml, 'text/html');
        const newCartItems = drawerDoc.querySelector('cart-drawer-items');
        const currentCartItems = document.querySelector('cart-drawer-items');
        if (newCartItems && currentCartItems) {
          currentCartItems.replaceWith(newCartItems);
        }
        
        const newFooter = drawerDoc.querySelector('.cart-drawer__footer');
        const currentFooter = document.querySelector('.cart-drawer__footer');
        if (newFooter && currentFooter) {
          currentFooter.replaceWith(newFooter);
        }
        
        // Update icon
        const iconDoc = new DOMParser().parseFromString(iconHtml, 'text/html');
        const newCountBubble = iconDoc.querySelector('.cart-count-bubble');
        const currentCountBubble = document.querySelector('.cart-count-bubble');
        
        if (newCountBubble && currentCountBubble) {
          currentCountBubble.replaceWith(newCountBubble.cloneNode(true));
        } else if (newCountBubble && !currentCountBubble) {
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon) cartIcon.appendChild(newCountBubble.cloneNode(true));
        }
        
        console.log('✅ Cart UI updated!');
        isAddingGifts = false;
        initializeCartAlsoLikeSlider();
      })
      .catch(error => {
        console.error('❌ Error adding gifts:', error);
        isAddingGifts = false;
      });
    }
    // Remove book if cart < €65 and no amulet sets
    else if (!meetsMinimumSpend && !hasAmuletSetItem && bookInCart) {
      console.log('➖ Removing BOOK (cart < €65 and no amulet sets)');
      isRemovingGifts = true;
      
      const bookItem = cart.items.find(item => item.variant_id == BOOK_VARIANT_ID);
      if (bookItem) {
        const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        if (cartItems) {
          cartItems.updateQuantity(bookItem.index + 1, 0);
        }
      }
      
      setTimeout(() => { isRemovingGifts = false; }, 1000);
    }
    // Remove box if no amulet sets
    else if (!hasAmuletSetItem && giftBoxInCart) {
      console.log('➖ Removing BOX (no amulet sets in cart)');
      isRemovingGifts = true;
      
      const giftBoxItem = cart.items.find(item => item.variant_id == GIFT_BOX_VARIANT_ID);
      if (giftBoxItem) {
        const cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
        if (cartItems) {
          cartItems.updateQuantity(giftBoxItem.index + 1, 0);
        }
      }
      
      setTimeout(() => { isRemovingGifts = false; }, 1000);
    }
    else {
      console.log('ℹ️ No action needed');
    }
  })
  .catch(error => {
    console.error('❌ Error in checkCartAndAddGifts:', error);
    isAddingGifts = false;
    isRemovingGifts = false;
  });
}

// Initialize system
function initAutoAdd() {
  if (typeof PUB_SUB_EVENTS === 'undefined' || typeof subscribe === 'undefined') {
    console.log('⏳ Waiting for pubsub...');
    setTimeout(initAutoAdd, 100);
    return;
  }
  
  console.log('🚀 Initializing auto-add gift system...');
  
  fetchCollectionProducts();
  
  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    console.log('🔔 Cart update event from:', event.source);
    if (event.source !== 'auto-add-gifts') {
      setTimeout(() => {
        console.log('⏰ Running gift check...');
        checkCartAndAddGifts();
      }, 1000);
    }
  });
}

initAutoAdd();

*/